import React, { useRef } from 'react';
import { motion, useMotionValue, useSpring, useTransform } from 'framer-motion';
import { useMotion } from '../../context/MotionContext';

/**
 * Premium 3D hover tilt + cursor-following glare + accent glow.
 * Wrap card content; pass through className / data-testid via ...rest.
 */
export const TiltCard = ({ children, className = '', max = 7, ...rest }) => {
  const ref = useRef(null);
  const glareRef = useRef(null);
  const { prefersReducedMotion } = useMotion();

  const mvX = useMotionValue(0);
  const mvY = useMotionValue(0);
  const rotateX = useSpring(useTransform(mvY, [-0.5, 0.5], [max, -max]), { stiffness: 200, damping: 22 });
  const rotateY = useSpring(useTransform(mvX, [-0.5, 0.5], [-max, max]), { stiffness: 200, damping: 22 });

  const handleMove = (e) => {
    if (prefersReducedMotion || !ref.current) return;
    const r = ref.current.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width;
    const py = (e.clientY - r.top) / r.height;
    mvX.set(px - 0.5);
    mvY.set(py - 0.5);
    if (glareRef.current) {
      glareRef.current.style.setProperty('--gx', `${px * 100}%`);
      glareRef.current.style.setProperty('--gy', `${py * 100}%`);
    }
  };

  const handleLeave = () => {
    mvX.set(0);
    mvY.set(0);
  };

  if (prefersReducedMotion) {
    return (
      <div className={`tilt-card ${className}`} {...rest}>
        {children}
      </div>
    );
  }

  return (
    <motion.div
      ref={ref}
      onMouseMove={handleMove}
      onMouseLeave={handleLeave}
      style={{ rotateX, rotateY, transformPerspective: 1000 }}
      className={`tilt-card ${className}`}
      {...rest}
    >
      {children}
      <span ref={glareRef} className="tilt-glare" aria-hidden />
    </motion.div>
  );
};

export default TiltCard;
